var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal hide-footer no-stacking",
      attrs: {
        id: "ConfirmDeleteAuth0AccountModal",
        "data-test-hook": "modal-title-confirm-delete-auth0-acct-modal"
      }
    },
    [
      _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c(
            "div",
            { staticClass: "modal-header pb-1 pt-1 pr-0 align-items-center" },
            [
              _c(
                "h2",
                {
                  staticClass: "modal-title",
                  staticStyle: { "font-size": "1.25rem" }
                },
                [
                  _c("i", {
                    staticClass: "far fa-circle-exclamation colorOrange mr-1",
                    attrs: {
                      "data-test-hook":
                        "modal-heading-confirm-delete-auth0-acct-modal"
                    }
                  }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("xPleaseAcknowledgeDeletingEffects")) +
                      " "
                  )
                ]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-icon-button btn-icon-button--gray",
                  attrs: {
                    "data-test-hook":
                      "x-close-btn-confirm-delete-auth0-acct-modal"
                  },
                  on: {
                    click: function($event) {
                      _vm.trackAppInsightsEvent(
                        "ConfirmDeleteAuth0AccountModal-close-modal-pressed",
                        {
                          page: "Confirm Delete Auth0 Account Modal",
                          userId: _vm.accountProfile?.userId
                        }
                      ),
                        _vm.closeModal()
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-times fa-sm" })]
              )
            ]
          ),
          _c("div", { staticClass: "modal-body pt-0 pb-0" }, [
            _c(
              "div",
              { staticClass: "row mt-3", attrs: { "align-h": "around" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "col ml-0 mr-3",
                    attrs: {
                      "data-test-hook":
                        "modal-body-text-1-confirm-delete-auth0-acct-modal"
                    }
                  },
                  [
                    _c("b", [
                      _vm._v(_vm._s(_vm.$t("xThisProcessMayTakeDays")) + " ")
                    ])
                  ]
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "row mt-0", attrs: { "align-h": "around" } },
              [
                _c(
                  "b-row",
                  { staticClass: "mt-4 ml-0 mr-1" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            staticClass: "first-checkbox",
                            attrs: {
                              "data-test-hook":
                                "no-longer-able-to-use-ml-checkbox-consent"
                            },
                            model: {
                              value: _vm.notAbleToUseMLCheckbox,
                              callback: function($$v) {
                                _vm.notAbleToUseMLCheckbox = $$v
                              },
                              expression: "notAbleToUseMLCheckbox"
                            }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("xNoLongerAbleToUseML")) + " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "b-row",
                  { staticClass: "mt-3 ml-0 mr-1" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            attrs: {
                              "data-test-hook":
                                "ecobee-homes-removed-checkbox-consent"
                            },
                            model: {
                              value: _vm.ecobeeHomesRemovedCheckbox,
                              callback: function($$v) {
                                _vm.ecobeeHomesRemovedCheckbox = $$v
                              },
                              expression: "ecobeeHomesRemovedCheckbox"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("xEcobeeHomesWillBeRemoved")) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "b-row",
                  { staticClass: "mt-3 ml-0 mr-1 mb-2" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "d-flex align-items-center" },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            attrs: {
                              "data-test-hook":
                                "cannot-be-undone-checkbox-consent"
                            },
                            model: {
                              value: _vm.dataWillBeDeletedCheckbox,
                              callback: function($$v) {
                                _vm.dataWillBeDeletedCheckbox = $$v
                              },
                              expression: "dataWillBeDeletedCheckbox"
                            }
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("xCannotBeUndone")) + " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                this.showErrorText
                  ? _c(
                      "div",
                      {
                        staticClass: "row mt-2",
                        attrs: { "align-h": "around" }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "col ml-3 mr-3 text-danger",
                            attrs: {
                              "data-test-hook":
                                "error-text-confirm-delete-auth0-acct-modal"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("xMustAcknowledgeEffects")) +
                                " "
                            )
                          ]
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ]),
          _c("div", { staticClass: "modal-footer d-flex mt-3 p-0" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary my-3 ml-3",
                staticStyle: { flex: "1 1 0" },
                attrs: {
                  type: "button",
                  "data-test-hook": "cancel-btn-confirm-delete-auth0-acct-modal"
                },
                on: {
                  click: function($event) {
                    _vm.trackAppInsightsEvent(
                      "ConfirmDeleteAuth0AccountModal-close-modal-pressed",
                      {
                        page: "Confirm Delete Auth0 Account Modal",
                        userId: _vm.accountProfile?.userId
                      }
                    ),
                      _vm.closeModal()
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("xCancel")) + " ")]
            ),
            _c(
              "button",
              {
                staticClass: "btn btn-primary my-3 mr-3",
                staticStyle: { flex: "1 1 0" },
                attrs: {
                  "data-test-hook": "delete-btn-confirm-delete-auth0-acct-modal"
                },
                on: {
                  click: function($event) {
                    return _vm.onDeleteAccountPress()
                  }
                }
              },
              [_vm._v(" " + _vm._s(_vm.$t("xDeleteAccountBtn")) + " ")]
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }